<template>
  <job-content-table-outline
    :title="title"
    :comment-highlights="commentHighlights"
    :highlight-mode="highlightMode"
    v-on="$listeners"
  >
    <template #body>
      <div class="sub">
        <job-content-table-sub
          v-for="(content, i) in contents"
          :key="`content-${i}`"
          class="pega-break"
          :target-id="targetIds[i]"
          :content="content"
        />
      </div>
    </template>
  </job-content-table-outline>
</template>

<script>
import JobContentTableOutline from '@/components/atoms/JobContentTableOutline'
import JobContentTableSub from '@/components/atoms/JobContentTableSub'

export default {
  components: {
    JobContentTableOutline,
    JobContentTableSub
  },
  props: {
    title: {
      type: String,
      required: true
    },
    targetIds: {
      type: Array,
      default: () => []
    },
    contents: {
      type: Array,
      default: () => []
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      default: false
    }
  }
}
</script>
